import { DriverLicenses } from '@yme/common/assets';
const { TypeA, TypeA1, TypeA2, TypeAM, TypeB, TypeB1, TypeBA, TypeBE, TypeP, TypeQ } = DriverLicenses;
export const ROLE_ICON = 'img';
export const MAP_LICENSE_TYPE_TO_ICON = {
    A: TypeA,
    A1: TypeA1,
    A2: TypeA2,
    AM: TypeAM,
    B: TypeB,
    B1: TypeB1,
    BA: TypeBA,
    BE: TypeBE,
    P: TypeP,
    Q: TypeQ,
};
export var ElectricType;
(function (ElectricType) {
    ElectricType["ELECTRIC_SCOOTER"] = "Electric Scooter";
})(ElectricType || (ElectricType = {}));
